import "./index.css";
import { InitApp } from "./App/InitApp";
(() => {
    InitApp();
})();
